import React from 'react'

import { Panels } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/PanelsForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = Panels

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/panels',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            flipped: false,
            largePanelImage: 'https://via.placeholder.com/600x400',
            largePanelImageAlt: '',
            largePanelImageLink: '',
            largePanelImageLinkExternal: false,
            smallPanelImageTop: 'https://via.placeholder.com/600x400',
            smallPanelImageTopAlt: '',
            smallPanelImageTopLink: '',
            smallPanelImageTopLinkExternal: false,
            smallPanelImageBottom: 'https://via.placeholder.com/600x400',
            smallPanelImageBottomAlt: '',
            smallPanelImageBottomLink: '',
            smallPanelImageBottomLinkExternal: false,
        }),
    }
}

export default createPlugin
